module.exports = __webpack_public_path__ + "Roboto-Black.woff2?59eb3601394dd87f30f82433fb39dd94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Black/Roboto-Black.woff2?v=2.137
// module id = 669
// module chunks = 7